import type { UsageRun } from "../types";
import { formatCost, formatSeconds, formatTime, runTypeLabel } from "../utils/format";
import { RunStatus } from "./RunStatus";
import { TABLE, TABLE_WRAPPER, TBODY, TD, TD_NUMBER, TH, TH_NUMBER, THEAD } from "./tableClasses";

const whatRan = (run: UsageRun) => run.command ?? run.agent ?? "—";

export const RunsTable = ({
  runs,
  onOpen,
}: {
  runs: UsageRun[];
  onOpen: (runId: string) => void;
}) => (
  <div className={TABLE_WRAPPER}>
    <table className={TABLE}>
      <thead className={THEAD}>
        <tr>
          <th className={TH}>Started</th>
          <th className={TH}>User</th>
          <th className={TH}>Run type</th>
          <th className={TH}>What ran</th>
          <th className={TH}>Status</th>
          <th className={TH_NUMBER}>Cost</th>
          <th className={TH_NUMBER}>Time</th>
          <th className={TH_NUMBER}>Calls</th>
        </tr>
      </thead>
      <tbody className={TBODY}>
        {runs.map((run) => (
          <tr key={run.id}>
            <td className={`${TD} whitespace-nowrap`}>
              <button
                type="button"
                aria-haspopup="dialog"
                onClick={() => onOpen(run.id)}
                className="rounded-sm text-left font-medium text-zinc-900 underline-offset-2 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900"
              >
                {formatTime(run.started_at)}
              </button>
            </td>
            <td className={`${TD} max-w-56 truncate`}>{run.user_email ?? run.user_id}</td>
            <td className={`${TD} whitespace-nowrap`}>{runTypeLabel(run.run_type, run.mode)}</td>
            <td className={`${TD} max-w-72 truncate font-mono text-xs`}>{whatRan(run)}</td>
            <td className={TD}>
              <RunStatus run={run} />
            </td>
            <td className={TD_NUMBER}>{formatCost(run.cost_usd)}</td>
            <td className={TD_NUMBER}>{formatSeconds(run.total_seconds)}</td>
            <td className={TD_NUMBER}>{run.calls.toLocaleString()}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
